;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ArtsSearchFilterController', ArtsSearchFilterController)

  /* @ngInject */
  function ArtsSearchFilterController ($scope, $translate, $rootScope, $timeout, $stateParams, $location, AdminService, GroupService, TagsService) {
    $scope.search = {
      formatId: null,
      customizationLevel: null,
      needApproval: null,
      groupId: null,
      creationFrom: null,
      creationTo: null,
      templateExpirationFrom: null,
      templateExpirationTo: null,
      isArchived: false,
      artTagIds: []
    }

    $scope.companyFeatures = {
      groupSegmentation: {
        access: false,
        data: {}
      }
    }

    $scope.approval = [
      { value: true, label: $translate.instant('yes') },
      { value: false, label: $translate.instant('no') }
    ]

    $scope.customizationLevels = [
      { value: 'FREE_STYLE', label: $translate.instant('permissionFree') },
      { value: 'RESTRICTED', label: $translate.instant('permissionRestricted') },
      { value: 'ONLY_DOWNLOAD', label: $translate.instant('permissionAuto') }
    ]

    $scope.selectedTab = 'creation'
    $scope.showCategoriesDropdown = false

    $scope.tagsIndex = 0
    $scope.tagsTop = 20

    const api = {
      _succesGetCompanyProducts,
      _successGetGroups,
      _successGetCategories,
      _setValuesInDropdown,
      _setSelectedTags,
      _stringToBoolean,
      _handleCompanyFeatures
    }
    this.getApi = () => api

    activate()

    function activate () {
      AdminService.getCustomerProducts().then(api._succesGetCompanyProducts)

      if (!$rootScope.isUser()) {
        GroupService.getGroups().then(api._successGetGroups)
      }

      TagsService.getTags({ top: $scope.tagsTop, skip: 0 }).then(res => {
        api._successGetCategories(res, true)

        if ($stateParams) {
          api._setValuesInDropdown($stateParams)
        }
      })

      api._handleCompanyFeatures()
    }

    const deregisterArtsClearArtsFilters = $rootScope.$on('arts.clear-arts-filters', () => {
      $scope.resetArtSearchFilters()
    })

    $scope.$on('$destroy', () => {
      deregisterArtsClearArtsFilters()
    })

    $scope.searchFiltersClick = function (filters) {
      if (filters.initialDate || filters.endDate) {
        if ($scope.selectedTab === 'creation') {
          filters.creationFrom = filters.initialDate
          filters.creationTo = filters.endDate
          filters.templateExpirationFrom = null
          filters.templateExpirationTo = null
        } else {
          filters.creationFrom = null
          filters.creationTo = null
          filters.templateExpirationFrom = filters.initialDate
          filters.templateExpirationTo = filters.endDate
        }
      }

      $scope.setFilters(filters)
    }

    $scope.changeDateTab = function (tab) {
      $scope.selectedTab = tab
      $location.search({ ...$stateParams, id: null, tab })
    }

    $scope.resetArtSearchFilters = function () {
      $scope.search = {
        formatId: null,
        customizationLevel: null,
        needApproval: null,
        groupId: null,
        creationFrom: null,
        creationTo: null,
        templateExpirationFrom: null,
        templateExpirationTo: null,
        isArchived: false,
        artTagIds: [],
        initialDate: null,
        endDate: null
      }

      $scope.categories.forEach(item => {
        item.selected = false
      })

      $timeout(() => {
        $('.arts-search-filter .search-inputs .format-dropdown .input-dropdown').dropdown('clear')
        $('.arts-search-filter .search-inputs .approval-dropdown .input-dropdown').dropdown('clear')
        $('.arts-search-filter .search-inputs .customization-dropdown .input-dropdown').dropdown('clear')
        $('.arts-search-filter .search-inputs .groups-dropdown .input-dropdown').dropdown('clear')
      }, 100, false)
    }

    $scope.showCategoriesDropdownClick = function () {
      $scope.showCategoriesDropdown = !$scope.showCategoriesDropdown
    }

    $scope.selectCategoryClick = function (category) {
      const tagIndex = $scope.search.artTagIds.findIndex(item => item === category.value)

      if (tagIndex !== -1) {
        $scope.search.artTagIds.splice(tagIndex, 1)
        category.selected = false
      } else {
        category.selected = true
        $scope.search.artTagIds.push(category.value)
      }
    }

    $scope.clearSelectedTags = function () {
      $scope.search.artTagIds = []
      $scope.categories.forEach(item => {
        item.selected = false
      })
    }

    $scope.showMoreTagsClick = function () {
      $scope.tagsIndex++

      TagsService.getTags({ top: $scope.tagsTop, skip: $scope.tagsTop * $scope.tagsIndex }).then(api._successGetCategories)
    }

    $scope.closeCategoriesDropdown = function () {
      $scope.showCategoriesDropdown = false
    }

    function _handleCompanyFeatures () {
      $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        $scope.companyFeatures.groupSegmentation = {
          access: !!features['ARTS.GROUPS_SEGMENTATION'],
          data: {
            featureName: $translate.instant('billingFeatures.artsGroupsSegmentation'),
            featureSlug: 'ARTS.GROUPS_SEGMENTATION'
          }
        }
      })
    }

    function _succesGetCompanyProducts (res) {
      const { rows } = res
      $scope.products = rows.map(item => {
        return { value: item.id, label: item.name }
      })
    }

    function _successGetGroups (res) {
      $scope.groups = res.d.results.map(item => {
        return { value: item.id, label: item.name }
      })
    }

    function _successGetCategories (res, reset) {
      if (reset) {
        $scope.categories = []
      }
      const tags = res.rows.map(item => {
        return { value: item.id, label: item.name, selected: false }
      })

      $scope.categoriesCount = res.count
      $scope.categories.push(...tags)
    }

    function _setValuesInDropdown (stateParams) {
      $scope.search.isArchived = api._stringToBoolean(stateParams.isArchived)
      $scope.search.needApproval = stateParams.needApproval === undefined ? null : api._stringToBoolean(stateParams.needApproval)

      if (stateParams.tab) {
        $scope.selectedTab = stateParams.tab
      }

      if (stateParams.initialDate) {
        $scope.search.initialDate = moment(stateParams.initialDate)
      }

      if (stateParams.endDate) {
        $scope.search.endDate = moment(stateParams.endDate)
      }

      if (stateParams.artTagIds) {
        $scope.search.artTagIds = Array.from(stateParams.artTagIds).map(Number)
        $scope.categories.filter(api._setSelectedTags)
      }

      $timeout(() => {
        $('.format-dropdown .input-dropdown').dropdown('set selected', stateParams.formatId)
        $('.approval-dropdown .input-dropdown').dropdown('set selected', stateParams.needApproval)
        $('.customization-dropdown .input-dropdown').dropdown('set selected', stateParams.customizationLevel)
        $('.groups-dropdown .input-dropdown').dropdown('set selected', stateParams.groupId)
      }, 2000, false)
    }

    function _setSelectedTags (category) {
      const categorySelected = $scope.search.artTagIds.some(tagId => {
        return tagId === category.value
      })

      if (categorySelected) {
        category.selected = true
      }
    }

    function _stringToBoolean (string = '') {
      return String(string).toLowerCase() === 'true'
    }
  }
})()
